// extracted by mini-css-extract-plugin
module.exports = {"messageContainer":"_2R7JQ7lR7YBMhHy0742Xbp","messageText":"KwAyzJ-PtB9KiGLhW9PV7"};